import { useEffect } from 'react';

const APP_NAME = 'UniCore';

/**
 * Устанавливает document.title. Без аргумента или с пустой строкой — только имя приложения.
 */
export function useDocumentTitle(title?: string | null): void {
  useEffect(() => {
    document.title = title?.trim() ? `${title.trim()} — ${APP_NAME}` : APP_NAME;
  }, [title]);
}

export { APP_NAME };
